import React from 'react'
const Common = React.createContext({auth: null,currentOrg: null, updatePermissions: null});

export default Common
